import { render, staticRenderFns } from "./EmailComposer.vue?vue&type=template&id=508eb901"
import script from "./EmailComposer.vue?vue&type=script&lang=js"
export * from "./EmailComposer.vue?vue&type=script&lang=js"
import style0 from "./EmailComposer.vue?vue&type=style&index=0&id=508eb901&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports